import { BiCardData, BiDashboardView } from '@euler/model/bi/dashboard';

// Captured from the dev rear (store 323, member 3855) over the BiService hop:
// the dashboard as created, and each card's data. The status column's
// value labels are as rear sends them since coded values carry labels.

export const kBiStyleDashboardCaptured = {
  id: 'bidash_01m542jaeqvbtap65w1fr5z34e',
  name: '经营样式测试',
  description: null,
  visibility: 1,
  ownerMemberId: 3855,
  ownerName: '测试店长',
  isDefault: false,
  revision: 2,
  permission: 'manage',
  updatedAt: '2026-10-17T04:40:19.000Z',
  layout: {
    mode: 'preset',
    columns: 'auto',
    order: [
      'bicard_01m542jap0jq4tk31takche4za',
      'bicard_01m542jap13mye039jn6ffz1b3',
      'bicard_01m542jap1hrafc7kva88qk9gv',
      'bicard_01m542jap20ysg67pvzmjvthq6',
      'bicard_01m542jap2h9bth4adpebqprb7',
      'bicard_01m542jap2qweq997s1bvcmkev',
      'bicard_01m542jap3ts0ajnd65h8x52wd',
      'bicard_01m542jap30xnpgf4rmyns2jj9',
      'bicard_01m542jap40sab90ntc2gg6b3t',
      'bicard_01m542jap4xhvx8958855ekse6',
    ],
  },
  filters: {},
  palette: 'warm',
  cards: [
    {
      id: 'bicard_01m542jap0jq4tk31takche4za',
      title: '各服务类型工单数',
      spec: {
        dataset: {
          kind: 'sql',
          model: 'orders',
        },
        measures: [
          {
            kind: 'field',
            field: 'order_count',
          },
        ],
        dimensions: [
          {
            field: 'service_type',
          },
        ],
        filters: [],
        sort: [
          {
            key: 'order_count',
            dir: 'desc',
          },
        ],
        timeRange: {
          kind: 'relative',
          preset: 'last_12_months',
        },
      },
      viz: {
        type: 'bar',
        x: 'service_type',
        series: [
          {
            key: 'order_count',
          },
        ],
        style: {
          title: {
            show: true,
            align: 'center',
          },
          subtitle: '不含已取消',
          legend: {
            show: false,
            position: 'bottom',
          },
          axes: {
            x: {
              show: true,
              labelRotate: 45,
            },
            y: {
              show: true,
              label: '工单数',
            },
          },
          gridLines: false,
          dataLabels: true,
          bar: {
            cornerRadius: 8,
            gap: 'wide',
          },
        },
      },
      sourceDraftId: 'bidraft_01m542jag0v7hak5rzgnty1tpw',
      createdBy: 3855,
      createdAt: '2026-10-17T04:40:19.000Z',
      updatedAt: '2026-10-17T04:40:19.000Z',
    },
    {
      id: 'bicard_01m542jap13mye039jn6ffz1b3',
      title: '每月工单趋势',
      spec: {
        dataset: {
          kind: 'sql',
          model: 'orders',
        },
        measures: [
          {
            kind: 'field',
            field: 'order_count',
          },
        ],
        dimensions: [
          {
            field: 'created_at',
            grain: 'month',
          },
        ],
        filters: [],
        sort: [],
        timeRange: {
          kind: 'relative',
          preset: 'last_12_months',
        },
      },
      viz: {
        type: 'line',
        x: 'created_at__month',
        series: [
          {
            key: 'order_count',
          },
        ],
        style: {
          seriesColors: {
            order_count: 'green',
          },
          line: {
            width: 3,
            smooth: true,
            showPoints: false,
          },
        },
      },
      sourceDraftId: 'bidraft_01m542jagcm6ttwg4fs89ga61z',
      createdBy: 3855,
      createdAt: '2026-10-17T04:40:19.000Z',
      updatedAt: '2026-10-17T04:40:19.000Z',
    },
    {
      id: 'bicard_01m542jap1hrafc7kva88qk9gv',
      title: '每周开单与完工',
      spec: {
        dataset: {
          kind: 'sql',
          model: 'orders',
        },
        measures: [
          {
            kind: 'field',
            field: 'order_count',
          },
          {
            kind: 'field',
            field: 'finished_count',
          },
        ],
        dimensions: [
          {
            field: 'created_at',
            grain: 'week',
          },
        ],
        filters: [],
        sort: [],
        timeRange: {
          kind: 'absolute',
          from: '2026-02-01',
          to: '2026-05-31',
        },
      },
      viz: {
        type: 'area',
        x: 'created_at__week',
        series: [
          {
            key: 'order_count',
          },
          {
            key: 'finished_count',
          },
        ],
        style: {
          palette: 'vivid',
          legend: {
            show: true,
            position: 'top',
          },
          line: {
            width: 1,
            smooth: true,
            showPoints: true,
          },
        },
      },
      sourceDraftId: 'bidraft_01m542jagv3gt64r7g1nad3xv3',
      createdBy: 3855,
      createdAt: '2026-10-17T04:40:19.000Z',
      updatedAt: '2026-10-17T04:40:19.000Z',
    },
    {
      id: 'bicard_01m542jap20ysg67pvzmjvthq6',
      title: '每月各服务类型工单',
      spec: {
        dataset: {
          kind: 'sql',
          model: 'orders',
        },
        measures: [
          {
            kind: 'field',
            field: 'order_count',
          },
        ],
        dimensions: [
          {
            field: 'created_at',
            grain: 'month',
          },
          {
            field: 'service_type',
          },
        ],
        filters: [],
        sort: [],
        timeRange: {
          kind: 'relative',
          preset: 'last_12_months',
        },
      },
      viz: {
        type: 'stacked_bar',
        x: 'created_at__month',
        series: [
          {
            key: 'order_count',
          },
        ],
        seriesBy: 'service_type',
        style: {
          legend: {
            show: true,
            position: 'right',
          },
          bar: {
            cornerRadius: 0,
            gap: 'narrow',
          },
        },
      },
      sourceDraftId: 'bidraft_01m542jahmy87yfxfdh2bx1fkn',
      createdBy: 3855,
      createdAt: '2026-10-17T04:40:19.000Z',
      updatedAt: '2026-10-17T04:40:19.000Z',
    },
    {
      id: 'bicard_01m542jap2h9bth4adpebqprb7',
      title: '服务顾问工单排行',
      spec: {
        dataset: {
          kind: 'sql',
          model: 'orders',
        },
        measures: [
          {
            kind: 'field',
            field: 'order_count',
          },
        ],
        dimensions: [
          {
            field: 'service_agent',
          },
        ],
        filters: [],
        sort: [
          {
            key: 'order_count',
            dir: 'desc',
          },
        ],
        timeRange: {
          kind: 'relative',
          preset: 'last_12_months',
        },
        limit: 8,
      },
      viz: {
        type: 'horizontal_bar',
        x: 'service_agent',
        series: [
          {
            key: 'order_count',
            name: '工单数',
          },
        ],
        style: {
          axes: {
            y: {
              show: false,
            },
          },
          gridLines: false,
          dataLabels: true,
        },
      },
      sourceDraftId: 'bidraft_01m542jaj8j3b7epa9nn3zqgy4',
      createdBy: 3855,
      createdAt: '2026-10-17T04:40:19.000Z',
      updatedAt: '2026-10-17T04:40:19.000Z',
    },
    {
      id: 'bicard_01m542jap2qweq997s1bvcmkev',
      title: '工单状态占比',
      spec: {
        dataset: {
          kind: 'sql',
          model: 'orders',
        },
        measures: [
          {
            kind: 'field',
            field: 'order_count',
          },
        ],
        dimensions: [
          {
            field: 'status',
          },
        ],
        filters: [],
        sort: [],
        timeRange: {
          kind: 'relative',
          preset: 'last_12_months',
        },
      },
      viz: {
        type: 'pie',
        x: 'status',
        series: [
          {
            key: 'order_count',
          },
        ],
        style: {
          pie: {
            innerRadius: 0,
            showPercent: true,
          },
        },
      },
      sourceDraftId: 'bidraft_01m542jajva8ht6b2nhwkv42cg',
      createdBy: 3855,
      createdAt: '2026-10-17T04:40:19.000Z',
      updatedAt: '2026-10-17T04:40:19.000Z',
    },
    {
      id: 'bicard_01m542jap30xnpgf4rmyns2jj9',
      title: '各服务类型明细',
      spec: {
        dataset: {
          kind: 'sql',
          model: 'orders',
        },
        measures: [
          {
            kind: 'field',
            field: 'order_count',
          },
          {
            kind: 'field',
            field: 'finished_count',
          },
          {
            kind: 'field',
            field: 'turnaround',
            agg: 'avg',
          },
        ],
        dimensions: [
          {
            field: 'service_type',
          },
        ],
        filters: [],
        sort: [],
        timeRange: {
          kind: 'relative',
          preset: 'last_12_months',
        },
      },
      viz: {
        type: 'table',
        columns: [
          {
            key: 'service_type',
          },
          {
            key: 'order_count',
          },
          {
            key: 'finished_count',
          },
          {
            key: 'turnaround__avg',
          },
        ],
        style: {
          table: {
            density: 'compact',
            zebra: true,
            totalsRow: true,
          },
        },
      },
      sourceDraftId: 'bidraft_01m542jam9d2j3e1wkeexcgzvp',
      createdBy: 3855,
      createdAt: '2026-10-17T04:40:19.000Z',
      updatedAt: '2026-10-17T04:40:19.000Z',
    },
    {
      id: 'bicard_01m542jap3ts0ajnd65h8x52wd',
      title: '车辆品牌分布',
      spec: {
        dataset: {
          kind: 'sql',
          model: 'orders',
        },
        measures: [
          {
            kind: 'field',
            field: 'order_count',
          },
        ],
        dimensions: [
          {
            field: 'vehicle_brand',
          },
        ],
        filters: [],
        sort: [
          {
            key: 'order_count',
            dir: 'desc',
          },
        ],
        timeRange: {
          kind: 'relative',
          preset: 'last_12_months',
        },
        limit: 6,
      },
      viz: {
        type: 'donut',
        x: 'vehicle_brand',
        series: [
          {
            key: 'order_count',
          },
        ],
        style: {
          legend: {
            show: true,
            position: 'right',
          },
          dataLabels: true,
          pie: {
            innerRadius: 0.4,
            showPercent: false,
          },
        },
      },
      sourceDraftId: 'bidraft_01m542jakf0zhgreq745hshzz1',
      createdBy: 3855,
      createdAt: '2026-10-17T04:40:19.000Z',
      updatedAt: '2026-10-17T04:40:19.000Z',
    },
    {
      id: 'bicard_01m542jap40sab90ntc2gg6b3t',
      title: '2026 年 5 月平均维修时长',
      spec: {
        dataset: {
          kind: 'sql',
          model: 'orders',
        },
        measures: [
          {
            kind: 'field',
            field: 'turnaround',
            agg: 'avg',
          },
        ],
        dimensions: [],
        filters: [],
        sort: [],
        timeRange: {
          kind: 'absolute',
          from: '2026-05-01',
          to: '2026-05-31',
        },
      },
      viz: {
        type: 'kpi',
        value: 'turnaround__avg',
        compare: 'previous_period',
        style: {
          kpi: {
            showDelta: true,
            deltaGoodWhen: 'down',
          },
        },
      },
      sourceDraftId: 'bidraft_01m542jampb78d78wapqkj7fy6',
      createdBy: 3855,
      createdAt: '2026-10-17T04:40:19.000Z',
      updatedAt: '2026-10-17T04:40:19.000Z',
    },
    {
      id: 'bicard_01m542jap4xhvx8958855ekse6',
      title: '每月工单（默认样式）',
      spec: {
        dataset: {
          kind: 'sql',
          model: 'orders',
        },
        measures: [
          {
            kind: 'field',
            field: 'order_count',
          },
          {
            kind: 'field',
            field: 'finished_count',
          },
        ],
        dimensions: [
          {
            field: 'created_at',
            grain: 'month',
          },
        ],
        filters: [],
        sort: [],
        timeRange: {
          kind: 'relative',
          preset: 'last_12_months',
        },
      },
      viz: {
        type: 'bar',
        x: 'created_at__month',
        series: [
          {
            key: 'order_count',
          },
          {
            key: 'finished_count',
          },
        ],
      },
      sourceDraftId: 'bidraft_01m542janbbbrbn98wtmdpkfbe',
      createdBy: 3855,
      createdAt: '2026-10-17T04:40:19.000Z',
      updatedAt: '2026-10-17T04:40:19.000Z',
    },
  ],
  createdAt: '2026-10-17T04:40:19.000Z',
} as unknown as BiDashboardView;

export const kBiStyleCardDataCaptured = {
  bicard_01m542jap0jq4tk31takche4za: {
    state: 'ready',
    cardId: 'bicard_01m542jap0jq4tk31takche4za',
    result: {
      current: {
        columns: [
          {
            key: 'service_type',
            label: {
              zh: '服务类型',
              en: 'Service type',
            },
            type: 'string',
            role: 'dimension',
          },
          {
            key: 'order_count',
            label: {
              zh: '工单数',
              en: 'Orders',
            },
            type: 'number',
            role: 'measure',
            format: { kind: 'number', decimals: 0 },
          },
        ],
        rows: [
          ['常规保养,', 5814],
          ['保险事故,', 1752],
          ['常规检查,', 1739],
          ['普通维修,', 437],
          ['新能源服务,', 411],
          ['索赔行动,', 374],
          ['保险事故,常规保养,', 5],
          ['自费钣喷,', 5],
          ['保险事故,自费钣喷,', 2],
          ['常规检查,普通维修,', 2],
          ['保险事故,常规检查,', 1],
          ['常规检查,常规保养,', 1],
          ['常规检查,索赔行动,', 1],
          ['新能源服务,索赔行动,', 1],
          ['普通维修,常规检查,', 1],
          ['普通维修,新能源服务,', 1],
        ],
        truncated: false,
        asOf: '2026-10-17T04:40:19.925Z',
        window: {
          from: '2025-11-01',
          to: '2026-10-31',
        },
      },
    },
    dateFilter: 'none',
  },
  bicard_01m542jap13mye039jn6ffz1b3: {
    state: 'ready',
    cardId: 'bicard_01m542jap13mye039jn6ffz1b3',
    result: {
      current: {
        columns: [
          {
            key: 'created_at__month',
            label: {
              zh: '开单时间（月）',
              en: 'Opened at (month)',
            },
            type: 'string',
            role: 'dimension',
          },
          {
            key: 'order_count',
            label: {
              zh: '工单数',
              en: 'Orders',
            },
            type: 'number',
            role: 'measure',
            format: { kind: 'number', decimals: 0 },
          },
        ],
        rows: [
          ['2025-11', 1494],
          ['2025-12', 1501],
          ['2026-01', 1687],
          ['2026-02', 1643],
          ['2026-03', 1579],
          ['2026-04', 1407],
          ['2026-05', 1236],
        ],
        truncated: false,
        asOf: '2026-10-17T04:40:19.946Z',
        window: {
          from: '2025-11-01',
          to: '2026-10-31',
        },
      },
    },
    dateFilter: 'none',
  },
  bicard_01m542jap1hrafc7kva88qk9gv: {
    state: 'ready',
    cardId: 'bicard_01m542jap1hrafc7kva88qk9gv',
    result: {
      current: {
        columns: [
          {
            key: 'created_at__week',
            label: {
              zh: '开单时间（周）',
              en: 'Opened at (week)',
            },
            type: 'string',
            role: 'dimension',
          },
          {
            key: 'order_count',
            label: {
              zh: '工单数',
              en: 'Orders',
            },
            type: 'number',
            role: 'measure',
            format: { kind: 'number', decimals: 0 },
          },
          {
            key: 'finished_count',
            label: {
              zh: '已完工数',
              en: 'Finished orders',
            },
            type: 'number',
            role: 'measure',
            format: { kind: 'number', decimals: 0 },
          },
        ],
        rows: [
          ['2026-01-26', 84, 83],
          ['2026-02-02', 530, 515],
          ['2026-02-09', 459, 446],
          ['2026-02-16', 130, 122],
          ['2026-02-23', 532, 518],
          ['2026-03-02', 413, 403],
          ['2026-03-09', 350, 340],
          ['2026-03-16', 305, 298],
          ['2026-03-23', 340, 328],
          ['2026-03-30', 297, 288],
          ['2026-04-06', 362, 351],
          ['2026-04-13', 307, 293],
          ['2026-04-20', 333, 324],
          ['2026-04-27', 328, 320],
          ['2026-05-04', 378, 367],
          ['2026-05-11', 327, 315],
          ['2026-05-18', 313, 284],
          ['2026-05-25', 77, 43],
        ],
        truncated: false,
        asOf: '2026-10-17T04:40:19.956Z',
        window: {
          from: '2026-02-01',
          to: '2026-05-31',
        },
      },
    },
    dateFilter: 'none',
  },
  bicard_01m542jap20ysg67pvzmjvthq6: {
    state: 'ready',
    cardId: 'bicard_01m542jap20ysg67pvzmjvthq6',
    result: {
      current: {
        columns: [
          {
            key: 'created_at__month',
            label: {
              zh: '开单时间（月）',
              en: 'Opened at (month)',
            },
            type: 'string',
            role: 'dimension',
          },
          {
            key: 'service_type',
            label: {
              zh: '服务类型',
              en: 'Service type',
            },
            type: 'string',
            role: 'dimension',
          },
          {
            key: 'order_count',
            label: {
              zh: '工单数',
              en: 'Orders',
            },
            type: 'number',
            role: 'measure',
            format: { kind: 'number', decimals: 0 },
          },
        ],
        rows: [
          ['2025-11', '保险事故,', 261],
          ['2025-11', '保险事故,常规保养,', 3],
          ['2025-11', '保险事故,自费钣喷,', 1],
          ['2025-11', '常规保养,', 809],
          ['2025-11', '常规检查,', 240],
          ['2025-11', '常规检查,索赔行动,', 1],
          ['2025-11', '新能源服务,', 57],
          ['2025-11', '普通维修,', 65],
          ['2025-11', '索赔行动,', 56],
          ['2025-11', '自费钣喷,', 1],
          ['2025-12', '保险事故,', 254],
          ['2025-12', '保险事故,自费钣喷,', 1],
          ['2025-12', '常规保养,', 804],
          ['2025-12', '常规检查,', 243],
          ['2025-12', '常规检查,普通维修,', 1],
          ['2025-12', '新能源服务,', 61],
          ['2025-12', '新能源服务,索赔行动,', 1],
          ['2025-12', '普通维修,', 71],
          ['2025-12', '普通维修,常规检查,', 1],
          ['2025-12', '普通维修,新能源服务,', 1],
          ['2025-12', '索赔行动,', 63],
          ['2026-01', '保险事故,', 236],
          ['2026-01', '保险事故,常规保养,', 1],
          ['2026-01', '常规保养,', 984],
          ['2026-01', '常规检查,', 260],
          ['2026-01', '常规检查,普通维修,', 1],
          ['2026-01', '新能源服务,', 60],
          ['2026-01', '普通维修,', 75],
          ['2026-01', '索赔行动,', 70],
          ['2026-02', '保险事故,', 280],
          ['2026-02', '常规保养,', 929],
          ['2026-02', '常规检查,', 274],
          ['2026-02', '常规检查,常规保养,', 1],
          ['2026-02', '新能源服务,', 61],
          ['2026-02', '普通维修,', 67],
          ['2026-02', '索赔行动,', 31],
          ['2026-03', '保险事故,', 278],
          ['2026-03', '保险事故,常规保养,', 1],
          ['2026-03', '保险事故,常规检查,', 1],
          ['2026-03', '常规保养,', 875],
          ['2026-03', '常规检查,', 248],
          ['2026-03', '新能源服务,', 52],
          ['2026-03', '普通维修,', 64],
          ['2026-03', '索赔行动,', 58],
          ['2026-03', '自费钣喷,', 2],
          ['2026-04', '保险事故,', 237],
          ['2026-04', '常规保养,', 756],
          ['2026-04', '常规检查,', 245],
          ['2026-04', '新能源服务,', 61],
          ['2026-04', '普通维修,', 58],
          ['2026-04', '索赔行动,', 48],
          ['2026-04', '自费钣喷,', 2],
          ['2026-05', '保险事故,', 206],
          ['2026-05', '常规保养,', 657],
          ['2026-05', '常规检查,', 229],
          ['2026-05', '新能源服务,', 59],
          ['2026-05', '普通维修,', 37],
          ['2026-05', '索赔行动,', 48],
        ],
        truncated: false,
        asOf: '2026-10-17T04:40:19.970Z',
        window: {
          from: '2025-11-01',
          to: '2026-10-31',
        },
      },
    },
    dateFilter: 'none',
  },
  bicard_01m542jap2h9bth4adpebqprb7: {
    state: 'ready',
    cardId: 'bicard_01m542jap2h9bth4adpebqprb7',
    result: {
      current: {
        columns: [
          {
            key: 'service_agent',
            label: {
              zh: '服务顾问',
              en: 'Service advisor',
            },
            type: 'string',
            role: 'dimension',
          },
          {
            key: 'order_count',
            label: {
              zh: '工单数',
              en: 'Orders',
            },
            type: 'number',
            role: 'measure',
            format: { kind: 'number', decimals: 0 },
          },
        ],
        rows: [
          ['宋建雄', 1439],
          ['郭杰', 1318],
          ['刘鑫', 1296],
          ['赵宽顺', 1276],
          ['陈阳', 1197],
          ['李林', 1188],
          ['李颖', 1064],
          ['崔立新', 517],
        ],
        truncated: true,
        asOf: '2026-10-17T04:40:19.993Z',
        window: {
          from: '2025-11-01',
          to: '2026-10-31',
        },
      },
    },
    dateFilter: 'none',
  },
  bicard_01m542jap2qweq997s1bvcmkev: {
    state: 'ready',
    cardId: 'bicard_01m542jap2qweq997s1bvcmkev',
    result: {
      current: {
        columns: [
          {
            key: 'status',
            label: {
              zh: '工单状态',
              en: 'Status',
            },
            type: 'string',
            role: 'dimension',
            valueLabels: {
              pending: '待处理',
              inprogress: '进行中',
              cancelled: '已取消',
              finished: '已完成',
            },
          },
          {
            key: 'order_count',
            label: {
              zh: '工单数',
              en: 'Orders',
            },
            type: 'number',
            role: 'measure',
            format: { kind: 'number', decimals: 0 },
          },
        ],
        rows: [
          ['finished', 10214],
          ['cancelled', 243],
          ['inprogress', 90],
        ],
        truncated: false,
        asOf: '2026-10-17T04:40:20.013Z',
        window: {
          from: '2025-11-01',
          to: '2026-10-31',
        },
      },
    },
    dateFilter: 'none',
  },
  bicard_01m542jap30xnpgf4rmyns2jj9: {
    state: 'ready',
    cardId: 'bicard_01m542jap30xnpgf4rmyns2jj9',
    result: {
      current: {
        columns: [
          {
            key: 'service_type',
            label: {
              zh: '服务类型',
              en: 'Service type',
            },
            type: 'string',
            role: 'dimension',
          },
          {
            key: 'order_count',
            label: {
              zh: '工单数',
              en: 'Orders',
            },
            type: 'number',
            role: 'measure',
            format: { kind: 'number', decimals: 0 },
          },
          {
            key: 'finished_count',
            label: {
              zh: '已完工数',
              en: 'Finished orders',
            },
            type: 'number',
            role: 'measure',
            format: { kind: 'number', decimals: 0 },
          },
          {
            key: 'turnaround__avg',
            label: {
              zh: '交付时长（平均）',
              en: 'Turnaround (average)',
            },
            type: 'number',
            role: 'measure',
            format: { kind: 'duration' },
          },
        ],
        rows: [
          ['常规保养,', 5814, 5723, 827.7592],
          ['保险事故,', 1752, 1637, 7034.5535],
          ['常规检查,', 1739, 1664, 1769.4093],
          ['普通维修,', 437, 422, 1724.3412],
          ['新能源服务,', 411, 408, 913.3529],
          ['索赔行动,', 374, 340, 1576.2529],
          ['保险事故,常规保养,', 5, 5, 21553.2],
          ['自费钣喷,', 5, 5, 1887.2],
          ['保险事故,自费钣喷,', 2, 2, 7358],
          ['常规检查,普通维修,', 2, 2, 990.5],
          ['保险事故,常规检查,', 1, 1, 4630],
          ['常规检查,常规保养,', 1, 1, 4303],
          ['常规检查,索赔行动,', 1, 1, 1961],
          ['新能源服务,索赔行动,', 1, 1, 2466],
          ['普通维修,常规检查,', 1, 1, 325],
          ['普通维修,新能源服务,', 1, 1, 72],
        ],
        truncated: false,
        asOf: '2026-10-17T04:40:20.033Z',
        window: {
          from: '2025-11-01',
          to: '2026-10-31',
        },
      },
    },
    dateFilter: 'none',
  },
  bicard_01m542jap3ts0ajnd65h8x52wd: {
    state: 'ready',
    cardId: 'bicard_01m542jap3ts0ajnd65h8x52wd',
    result: {
      current: {
        columns: [
          {
            key: 'vehicle_brand',
            label: {
              zh: '品牌',
              en: 'Brand',
            },
            type: 'string',
            role: 'dimension',
          },
          {
            key: 'order_count',
            label: {
              zh: '工单数',
              en: 'Orders',
            },
            type: 'number',
            role: 'measure',
            format: { kind: 'number', decimals: 0 },
          },
        ],
        rows: [
          ['大众', 10498],
          ['奔驰', 11],
          ['丰田', 5],
          ['北京', 4],
          ['奥迪', 4],
          ['标致', 3],
        ],
        truncated: true,
        asOf: '2026-10-17T04:40:20.057Z',
        window: {
          from: '2025-11-01',
          to: '2026-10-31',
        },
      },
    },
    dateFilter: 'none',
  },
  bicard_01m542jap40sab90ntc2gg6b3t: {
    state: 'ready',
    cardId: 'bicard_01m542jap40sab90ntc2gg6b3t',
    result: {
      current: {
        columns: [
          {
            key: 'turnaround__avg',
            label: {
              zh: '交付时长（平均）',
              en: 'Turnaround (average)',
            },
            type: 'number',
            role: 'measure',
            format: { kind: 'duration' },
          },
        ],
        rows: [[1601.129]],
        truncated: false,
        asOf: '2026-10-17T04:40:20.076Z',
        window: {
          from: '2026-05-01',
          to: '2026-05-31',
        },
      },
      previous: {
        columns: [
          {
            key: 'turnaround__avg',
            label: {
              zh: '交付时长（平均）',
              en: 'Turnaround (average)',
            },
            type: 'number',
            role: 'measure',
            format: { kind: 'duration' },
          },
        ],
        rows: [[2049.4975]],
        truncated: false,
        asOf: '2026-10-17T04:40:20.076Z',
        window: {
          from: '2026-03-31',
          to: '2026-04-30',
        },
      },
    },
    dateFilter: 'none',
  },
  bicard_01m542jap4xhvx8958855ekse6: {
    state: 'ready',
    cardId: 'bicard_01m542jap4xhvx8958855ekse6',
    result: {
      current: {
        columns: [
          {
            key: 'created_at__month',
            label: {
              zh: '开单时间（月）',
              en: 'Opened at (month)',
            },
            type: 'string',
            role: 'dimension',
          },
          {
            key: 'order_count',
            label: {
              zh: '工单数',
              en: 'Orders',
            },
            type: 'number',
            role: 'measure',
            format: { kind: 'number', decimals: 0 },
          },
          {
            key: 'finished_count',
            label: {
              zh: '已完工数',
              en: 'Finished orders',
            },
            type: 'number',
            role: 'measure',
            format: { kind: 'number', decimals: 0 },
          },
        ],
        rows: [
          ['2025-11', 1494, 1455],
          ['2025-12', 1501, 1473],
          ['2026-01', 1687, 1648],
          ['2026-02', 1643, 1594],
          ['2026-03', 1579, 1536],
          ['2026-04', 1407, 1361],
          ['2026-05', 1236, 1147],
        ],
        truncated: false,
        asOf: '2026-10-17T04:40:20.085Z',
        window: {
          from: '2025-11-01',
          to: '2026-10-31',
        },
      },
    },
    dateFilter: 'none',
  },
} as unknown as Record<string, BiCardData>;
